/**
 * Phone normalization to E.164.
 *
 * US-default: the product operates in the US (crisis lines are 988 / US Crisis
 * Text Line / Trevor), so bare 10-digit and `1`-prefixed 11-digit numbers are
 * treated as US (`+1`). Numbers already in `+<country><number>` form are accepted
 * as-is after a digit/length check. Returns `null` when the input can't be
 * confidently converted — callers treat `null` as "invalid phone" rather than
 * guessing a country code.
 *
 * If international enrollment is ever needed, replace this with
 * `libphonenumber-js`; call sites only depend on the `(string) => string | null`
 * contract.
 */
export const normalizePhoneToE164 = (phone: string): string | null => {
    const trimmed = phone.trim();
    if (!trimmed) return null;

    const hasPlus = trimmed.startsWith("+");
    const digits = trimmed.replace(/\D/g, "");

    if (hasPlus) {
        // Already international: 8–15 digits per E.164, country code can't start with 0.
        if (digits.length < 8 || digits.length > 15 || digits.startsWith("0")) return null;
        return `+${digits}`;
    }

    // US defaults.
    if (digits.length === 10) return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;

    return null;
};
